import { isBoolean } from "@/utils/type/BooleanUtil";
import { isNumber } from "@/utils/type/NumberUtil";

export function isJson(obj) {
  try {
    const res = JSON.parse(typeof obj !== "object" ? obj : JSON.stringify(obj));
    if (res === null) {
      return false;
    } else if (isBoolean(res)) {
      return false;
    } else if (isNumber(res)) {
      return false;
    } else if (Array.isArray(res)) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
}
